import { render, staticRenderFns } from "./checkoutDetails.vue?vue&type=template&id=d023ef18"
import script from "./checkoutDetails.vue?vue&type=script&lang=js"
export * from "./checkoutDetails.vue?vue&type=script&lang=js"
import style0 from "./checkoutDetails.vue?vue&type=style&index=0&id=d023ef18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports